import React from 'react';
import { ContentCardsStyles as S } from './ContentCards.styles';
import ContentCard from '@stories/Components/Cards/ContentCard/ContentCard';
import { getSrcs } from '@helpers/image';
import { Device, until } from '@helpers/media';
export var ImageCroppingMode;
(function (ImageCroppingMode) {
    ImageCroppingMode[ImageCroppingMode["DEFAULT"] = 0] = "DEFAULT";
    ImageCroppingMode[ImageCroppingMode["MAINTAIN_ASPECT_RATIO"] = 1] = "MAINTAIN_ASPECT_RATIO";
})(ImageCroppingMode || (ImageCroppingMode = {}));
const ContentCards = ({ title, intro, cardsPerRow, cards, imageCroppingMode, showBlurredImage, titleUnderline, ...rest }) => {
    return (React.createElement(S.Container, { ...rest },
        React.createElement(S.TopSection, null,
            React.createElement(S.Title, { "data-show-underline": titleUnderline }, title),
            React.createElement(S.Intro, null, intro)),
        React.createElement(S.CardsGrid, { "data-cards-per-row": cardsPerRow }, cards.map((card, i) => {
            let srcs = getSrcs(card.image, 550, 300, 4, 388 / 230);
            let sizes = `${until(Device.Tablet)} 90vw, ${until(Device.Desktop)} 33vw, 400px`;
            if ((cards.length === 5 || cards.length === 6) &&
                (i === 4 || i === 5) &&
                cardsPerRow === 4 &&
                !showBlurredImage) {
                // Items 5 & 6 are going to be larger, load a larger image //
                srcs = getSrcs(card.image, 792, 300, 4, 792 / 230);
                sizes = `${until(Device.Tablet)} 90vw, ${until(Device.Desktop)} 50vw, 800px`;
                if (cards.length === 5) {
                    // Item 5 is going to be very large //
                    srcs = getSrcs(card.image, 1600, 300, 4, 1600 / 230);
                    sizes = `${until(Device.Tablet)} 90vw, ${until(Device.Desktop)} 50vw, 1600px`;
                }
            }
            return (React.createElement(ContentCard, { key: `ContentCards_Card_${i}`, ...card, srcs: srcs, sizes: sizes, imageCroppingMode: imageCroppingMode, showBlurredImage: showBlurredImage }));
        }))));
};
export default ContentCards;
